import { createFileRoute, Link } from "@tanstack/react-router"
import { AlertCircleIcon } from "lucide-react"
import * as z from "zod"

import { generateMetaTags } from "@repo/seo/generate-meta-tags"
import {
  Alert,
  AlertDescription,
  AlertTitle,
} from "@repo/ui/components/ui/alert"
import { buttonVariants } from "@repo/ui/components/ui/button"
import { pick } from "@repo/utils/collections"
import { sharedConfig } from "~/lib/config/shared"

const searchSchema = z.looseObject({
  message: z.string().catch(""),
})

export const Route = createFileRoute("/_auth-layout/auth/error")({
  component: ErrorScreen,
  validateSearch: searchSchema,
  beforeLoad: async () => {
    return {
      pageTitle: "Authentication Error",
    }
  },
  head: ({ match }) => ({
    meta: generateMetaTags({
      robots: ["noindex", "nofollow", "noarchive"],
      base: {
        title: `${match.context.pageTitle} | ${sharedConfig.appName}`,
        description: `Authentication error for ${sharedConfig.appName}`,
        url: new URL(match.fullPath, sharedConfig.baseUrl).toString(),
      },
    }),
  }),
  loaderDeps: ({ search }) => pick(search, ["message"]),
})

function ErrorScreen() {
  const { message } = Route.useSearch()

  return (
    <>
      <Alert variant="destructive">
        <AlertCircleIcon className="h-5 w-5" />
        <AlertTitle>Error</AlertTitle>
        <AlertDescription>{message}</AlertDescription>
      </Alert>
      <Link
        to="/auth/sign-in"
        className={buttonVariants({ variant: "default" })}
      >
        Go to sign in
      </Link>
    </>
  )
}
